import type { Service } from "../types";

// Mock data for useServices
export const mockServices: Service[] = [
  {
    id: "service_consultation",
    client_id: "demo_client",
    name: "Initial Consultation",
    description:
      "30-minute initial consultation to assess needs and requirements",
    duration: 30,
    schedule_id: "schedule_1",
    performers: { ids: ["performer_1", "performer_2"] },
    price: 3500, // $35 in cents
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "service_appointment",
    client_id: "demo_client",
    name: "Standard Appointment",
    description: "Standard 45-minute appointment",
    duration: 45,
    schedule_id: "schedule_1",
    performers: { ids: ["performer_1", "performer_2", "performer_3"] },
    price: 4500, // $45 in cents
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "service_meeting",
    client_id: "demo_client",
    name: "Extended Meeting",
    description: "In-depth 60-minute meeting session",
    duration: 60,
    schedule_id: "schedule_1",
    performers: { ids: ["performer_1"] },
    price: 6500, // $65 in cents
    created_at: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "service_session",
    client_id: "demo_client",
    name: "Complete Session",
    description: "Comprehensive 90-minute session for detailed consultation",
    duration: 90,
    schedule_id: "schedule_2",
    performers: { ids: ["performer_1", "performer_2"] },
    price: 9000, // $90 in cents
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
];
